import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=33877350&scoped=true&"
import script from "./Declare.vue?vue&type=script&lang=js&"
export * from "./Declare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33877350",
  null
  
)

export default component.exports